module.exports = __webpack_public_path__ + "images/emoji/bell.0167b13a2518ef4d7f7a.png";